var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUppercase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.402 7L3 17H5.232L5.963 14.72H9.521L10.251 17H12.483L9.086 7H6.402ZM6.493 13.069L7.706 9.285H7.783L8.994 13.069H6.493Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.692 12.967C20.487 12.609 20.219 12.331 19.888 12.132C19.561 11.933 19.21 11.826 18.834 11.81V11.712C19.177 11.634 19.482 11.502 19.748 11.316C20.017 11.127 20.229 10.886 20.383 10.593C20.537 10.297 20.614 9.953 20.614 9.563C20.614 9.062 20.492 8.619 20.248 8.235C20.004 7.848 19.64 7.545 19.156 7.327C18.672 7.109 18.067 7 17.342 7H13.397V17H17.607C18.345 17 18.965 16.88 19.469 16.639C19.973 16.398 20.353 16.071 20.609 15.658C20.869 15.241 20.999 14.768 20.999 14.237C20.999 13.745 20.897 13.322 20.692 12.967ZM15.481 8.709H17.064C17.526 8.709 17.882 8.82 18.132 9.041C18.385 9.262 18.512 9.554 18.512 9.915C18.512 10.179 18.446 10.405 18.315 10.594C18.187 10.783 18.01 10.929 17.786 11.033C17.565 11.134 17.311 11.184 17.026 11.184H15.481V8.709ZM18.45 14.935C18.184 15.16 17.76 15.272 17.18 15.272H15.482V12.616H17.228C17.562 12.616 17.849 12.676 18.089 12.797C18.333 12.917 18.52 13.083 18.652 13.295C18.783 13.507 18.849 13.751 18.849 14.027C18.849 14.405 18.716 14.707 18.45 14.935Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUppercase);
export default __webpack_public_path__ + "static/media/icon-uppercase.c7195eaef08cb8fe3c8851d269d61bfb.svg";
export { ForwardRef as ReactComponent };